import { Plus } from "lucide-react";
import { Link, NavLink } from "react-router";
import { cn } from "../ui";
import { phoneTabs } from "./navItems";

/** Phone tab bar: Home, Accounts, Activity, then a raised + as the last item (SPEC D12). */
export function TabBar() {
  return (
    <nav
      aria-label="Main"
      className="safe-bottom fixed inset-x-0 bottom-0 z-30 flex items-center justify-around border-t border-line bg-surface px-2 pt-1.5"
    >
      {phoneTabs.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          className={({ isActive }) =>
            cn(
              "flex min-h-11 min-w-14 flex-col items-center justify-center gap-0.5 text-[11.5px] font-bold text-muted no-underline",
              isActive && "text-accent-strong",
            )
          }
        >
          <Icon size={22} strokeWidth={2.2} aria-hidden />
          {label}
        </NavLink>
      ))}
      <Link
        to="/add"
        aria-label="Add transaction"
        className="-mt-[26px] grid size-[60px] place-items-center rounded-[20px] bg-accent text-white shadow-raised"
      >
        <Plus size={28} strokeWidth={2.6} aria-hidden />
      </Link>
    </nav>
  );
}
